
























































































































































































































































































import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import store from "@/store";
import moment from "moment";
//  @components
import GraphCard from "@/components/diagnosticsDetails/GraphCard.vue";
import BenchmarkCard from "@/components/diagnosticsDetails/BenchmarkCard.vue";
import StatisticsCard from "@/components/diagnosticsDetails/StatisticsCard.vue";
import LimitsCard from "@/components/diagnosticsDetails/LimitsCard.vue";
import StatusCard from "@/components/diagnostics/StatusCard.vue";
import BenchmarkInfoModal from "@/components/diagnosticsDetails/BenchmarkInfoModal.vue";
import PerformanceImpactModal from "@/components/diagnosticsDetails/PerformanceImpactModal.vue";
//  @types
import { LongTrendPeriodMeta } from "@/types/longTrendPeriodMeta";
import { ILongTrendPeriod } from "@/types/longTrendPeriod";
  import { IStatusCard } from "@/types/StatusCard";
//  @modules
import { getModule } from "vuex-module-decorators";
import LongTrendPeriodModule from "@/store/clients/LongTrendPeriod.module";
import SnackbarModule from "@/store/clients/Snackbar.module";
import LongTrendExportClient from "@/Scripts/clients/long-trend-export-client";

const LongTrendPeriod = getModule(LongTrendPeriodModule, store);
const Snackbar = getModule(SnackbarModule, store);


@Component({
  components: {
    GraphCard,
    BenchmarkCard,
    StatisticsCard,
    LimitsCard,
    BenchmarkInfoModal,
    StatusCard,
    PerformanceImpactModal,
  },
})
export default class DiagnosticsDetails extends Vue {
  @Ref("RefPerformanceImpactModal") RefPerformanceImpactModal!: any;
  @Prop({ type: String, default: "1203px" }) width!: string;
  @Prop() longTrendPeriods!: ILongTrendPeriod[];

  //  @Data
  isModalActive = false;
  BenchmarkInfoModal = false;
  PerformanceImpactModal = false;
  benchmarkMenuOpen = false;
  loading = true;
  exportExcelLoading = false;
  periodMeta!: LongTrendPeriodMeta;
  customBenchmarkPeriod = false;
  currentPeriod: any = null;
  points = 0;
  originalPoints: number | null = null;

  //  @Validators
  benchmarkPeriodRules = {
    required: (value: number) => !!value || "Value required",
    valid: (value: number) => (value >= 30 && value <= 1000) || "Enter value from 30 to 1000",
  };

  // @Watchers
  @Watch("longTrendPeriod", { immediate: true, deep: true })
  onLongTrendPeriodChange(newVal: ILongTrendPeriod) {
    if (newVal) {
      this.currentPeriod = {
        start: moment.utc(newVal.start).valueOf(),
        end: moment.utc(newVal.end).valueOf(),
        status: newVal.status,
      };
    }
  }

  @Watch("loading", { immediate: true })
  onLoaded(val: boolean): void {
    if (!val) {
      if (this.benchmarkPeriod) this.points = this.benchmarkPeriod;
    }
  }

  //  @Getters
  get meta(): LongTrendPeriodMeta | null {
    return LongTrendPeriod.meta;
  }
  get longTrendPeriod(): ILongTrendPeriod | null {
    return LongTrendPeriod.longTrendPeriod;
  }
  get isBenchmarking(): boolean | undefined {
    return this.longTrendPeriod?.isBenchmarking;
  }
  get title(): string {
    return this.meta?.description ? this.meta.description.split("-")[0] : "";
  }
  get hasNextPeriod(): boolean | undefined {
    return this.meta?.hasNextPeriod;
  }
  get hasPreviousPeriod(): boolean | undefined {
    return this.meta?.hasPreviousPeriod;
  }
  get nextPeriodStart(): string | undefined {
    return new Date(moment.utc(this.meta?.nextPeriodStartDate).valueOf()).toISOString();
  }
  get nextPeriodEnd(): string | undefined {
    return new Date(moment.utc(this.meta?.nextPeriodEndDate).valueOf()).toISOString();
  }
  get prevPeriodStart(): string | undefined {
    return new Date(moment.utc(this.meta?.previousPeriodStartDate).valueOf()).toISOString();
  }
  get prevPeriodEnd(): string | undefined {
    return new Date(moment.utc(this.meta?.previousPeriodEndDate).valueOf()).toISOString();
  }
  get benchmarkPeriod(): number | undefined {
    return this.longTrendPeriod?.benchmarkPeriod;
  }
  get isCloudCalculated(): boolean | undefined {
    return this.longTrendPeriod?.isCloudCalculated;
  }

  get isManualBenchmark(): boolean | undefined {
    return this.longTrendPeriod?.isManualBenchmark;
  }

  get performanceStatusVSBenchmark(): number | string {
    if (!this.longTrendPeriod?.trendline || !this.longTrendPeriod.benchmarkPoint) return "";
    return this.round(this.longTrendPeriod.trendline.end.y - this.longTrendPeriod.benchmarkPoint.y);
  }

  get pointCount(): number | undefined {
    return this.longTrendPeriod?.longTrendData.length;
  }

  get outlierPointsCount(): number | undefined {
    if (this.pointCount && this.longTrendPeriod) {
      return this.pointCount - this.longTrendPeriod.filteredLongTrendData.length;
    }
  }

  get requireBenchmarkPoints(): number | undefined {
    return this.isManualBenchmark ? 2 : this.longTrendPeriod?.benchmarkPeriod;
  }
  get remainingPointsCount(): number | undefined {
    if (this.requireBenchmarkPoints && this.longTrendPeriod) {
      return this.requireBenchmarkPoints - this.longTrendPeriod.filteredLongTrendData.length;
    }
  }

  get isBenchmarkPeriodChanged(): boolean {
    return this.points !== this.originalPoints;
  }

  get statusCardDataList(): IStatusCard[] {
    if (!this.longTrendPeriod) return [] as IStatusCard[];
    const statusCardDataList: IStatusCard[] = [
      {
        status: this.longTrendPeriod.status,
        header: "Performance Status",
        content: this.convertStatusStr,
        contentPrependIcon: this.performanceIcon,
        contentPrependIconColor: "BackgroundInfoPrimary",
        footer: this.showPrediction ? this.showPredictionByStatus : "",
        footerSeparator: this.showPrediction,
      },
      {
        header: this.title,
        content: `${this.performanceStatusVSBenchmark}%`,
        footer: "compared to benchmark",
        footerTooltip: "Benchmark is vessel performance immediately after a trend event",
      },
      {
        header: "Benchmark Level",
        content: this.longTrendPeriod.benchmarkPoint ? `${this.round(this.longTrendPeriod.benchmarkPoint.y)}%` : "Not Available",
        footer: "compared to baseline",
      },
    ];
    return statusCardDataList;
  }

  get periodsDateList(): any[] {
    if (!this.longTrendPeriods) return [];

    return this.longTrendPeriods.map(period => {
      return {
        start: moment.utc(period.start).valueOf(),
        end: moment.utc(period.end).valueOf(),
        status: period.status,
      };
    });
  }

  get convertStatusStr(): string {
    if (!this.longTrendPeriod) return "Unknown";
    if (this.longTrendPeriod.status === "Ok") return "Okay";
    if (this.longTrendPeriod.status === "NotOk") return "Not Okay";
    if (this.longTrendPeriod.status === "BenchMarking") return "Benchmarking";
    return this.longTrendPeriod.status ?? "Unknown";
  }

  get performanceIcon(): string {
    if (!this.longTrendPeriod) return "mdi-close-circle-outline";
    if (this.longTrendPeriod.status === "Ok") return "$StatusOk";
    if (this.longTrendPeriod.status === "Observe") return "$StatusObserve";
    if (this.longTrendPeriod.status === "NotOk") return "$StatusNotOk";
    if (this.longTrendPeriod.status === "BenchMarking") return "$StatusBenchmarking";
    return "mdi-close-circle-outline";
  }

  get showPrediction(): boolean {
    if (!this.longTrendPeriod?.isCurrent) return false;
    if (this.showYellowPrediction || this.showRedPrediction) return true;
    return false;
  }

  get showYellowPrediction(): boolean {
    if (!this.longTrendPeriod?.redLineReached) return true;
    const redLineReached = new Date(this.longTrendPeriod?.redLineReached).getTime();
    if (redLineReached > Date.now()) return true;
    return false;
  }

  get showRedPrediction(): boolean {
    if (!this.longTrendPeriod?.yellowLineReached) return true;
    const yellowLineReached = new Date(this.longTrendPeriod?.yellowLineReached).getTime();
    if (yellowLineReached > Date.now() || yellowLineReached < new Date(this.meta?.startDate!).getTime()) return true;
    return false;
  }

  get yellowPrediction(): string {
    if (!this.longTrendPeriod?.yellowLineReached) return "\"Observe\" not expected soon";
    const reachedDate = new Date(this.longTrendPeriod?.yellowLineReached).getTime();
    if (reachedDate < new Date(this.longTrendPeriod?.start!).getTime()) return "\"Observe\" not expected soon";
    if (reachedDate < Date.now()) {
      return `"Observe" was reached on ${this.$options.filters?.dateDMY(this.longTrendPeriod?.yellowLineReached)}.`;
    } else {
      return `Changes to "Observe" ${this.$options.filters?.dateDMY(this.longTrendPeriod?.yellowLineReached)}.`;
    }
  }

  get redPrediction(): string {
    if (!this.longTrendPeriod?.redLineReached) return "\"Not Okay\" not expected soon";
    const reachedDate = new Date(this.longTrendPeriod?.redLineReached).getTime();
    if (reachedDate < new Date(this.longTrendPeriod?.start!).getTime()) return "\"Not Okay\" not expected soon";
    if (reachedDate < Date.now()) {
      return `"Not Okay" was reached on ${this.$options.filters?.dateDMY(this.longTrendPeriod?.redLineReached)}.`;
    } else {
      return `Changes to "Not Okay" ${this.$options.filters?.dateDMY(this.longTrendPeriod?.redLineReached)}.`;
    }
  }

  get showPredictionByStatus(): string {
    const status = this.longTrendPeriod?.status;
    if (status === "Ok") {
      return this.yellowPrediction;
    }
    if (status === "Observe") {
      return this.redPrediction;
    }
    if (status === "BenchMarking") {
      return "No prediction available";
    }
    if (status === "NotOk") {
      return "At lowest performance threshold";
    }
    return "";
  }

  // @Methods
  async exportExcel(): Promise<void> {
    this.exportExcelLoading = true;
    try {
      await LongTrendExportClient.exportExcelPeriod(this.meta?.vesselId, this.meta?.longTrendId, this.meta?.startDate, this.meta?.endDate);
    } finally {
      setTimeout(() => {
        this.exportExcelLoading = false;
      }, 1000);
    }
  }

  onBenchmarkMenuInput(val: boolean) {
    if (val) {
      // Menu opened: store the original value
      this.originalPoints = this.points;
    } else {
      // Menu closed: revert if not saved
      if (this.points !== this.originalPoints) {
        this.points = this.originalPoints !== null ? this.originalPoints : 0;
      }
    }
  }

  formatDateForDisplay(date: any): string {
    return moment(date).format("D MMM YYYY");
  }

  trendPeriodPerformanceStatusIcon(status: string): string {
    if (status === "Ok") return "$StatusOk";
    if (status === "Observe") return "$StatusObserve";
    if (status === "NotOk") return "$StatusNotOk";
    if (status === "BenchMarking") return "$StatusBenchmarking";
    return "mdi-close-circle-outline";
  }

  onCurrentPeriodChange(): void {
    if (!this.currentPeriod) return;
    this.periodMeta.startDate = moment.utc(this.currentPeriod.start).toISOString();
    this.periodMeta.endDate = moment.utc(this.currentPeriod.end).toISOString();
    this.updateData();
  }

  nextPeriod(): void {
    if (this.nextPeriodStart && this.nextPeriodEnd) {
      this.periodMeta.startDate = this.nextPeriodStart;
      this.periodMeta.endDate = this.nextPeriodEnd;
    }
    this.updateData();
  }

  previousPeriod(): void {
    if (this.prevPeriodStart && this.prevPeriodEnd) {
      this.periodMeta.startDate = this.prevPeriodStart;
      this.periodMeta.endDate = this.prevPeriodEnd;
    }
    this.updateData();
  }

  open(data: LongTrendPeriodMeta): void {
    this.periodMeta = data;
    this.isModalActive = true;
    this.updateData();
  }

  close(): void {
    this.isModalActive = false;
    LongTrendPeriod.DELETE_DATA();
    this.RefPerformanceImpactModal.clear();
  }

  async updateData(): Promise<void> {
    this.customBenchmarkPeriod = false;
    this.loading = true;
    try {
      await Promise.all([
        LongTrendPeriod.updateMeta(this.periodMeta),
        LongTrendPeriod.updateLongTrendPeriod(this.periodMeta),
        LongTrendPeriod.updateStatistics(this.periodMeta),
        LongTrendPeriod.updateTrendLimits(this.periodMeta.vesselId),
      ]);
    } catch (error) {
      this.close();
      Snackbar.showSnackbar({ text: "Could not load trend period details" });
    } finally {
      this.loading = false;
    }
  }

  async customPeriod(): Promise<void> {
    const clonedMeta = Object.assign({}, this.periodMeta);
    const customPeriod = {
      customBenchmarkPeriod: this.points,
    };
    const data = Object.assign(clonedMeta, customPeriod);
    this.loading = true;
    await LongTrendPeriod.updateLongTrendPeriod(data);
    if (this.points !== -1) {
      this.customBenchmarkPeriod = true;
    } else {
      this.customBenchmarkPeriod = false;
    }
    this.loading = false;
    // Update original value after save
    this.originalPoints = this.points;
  }

  round(value: number, precision = 1): number {
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }
}
